/**
 * build-version.ts — Thin build metadata for UI display.
 *
 * H-03 fix: audit-log.ts (11,260 lines) was imported by Sidebar.tsx just to
 * read AUDIT_LOG[0].buildNumber. This thin file replaces that import so the
 * full sprint history log is NOT included in the production bundle.
 *
 * Update this file each sprint. DevCenter still lazily imports the full
 * audit-log.ts — that import is already tree-shaken from production builds
 * because DevCenter is gated by import.meta.env.DEV.
 */

export const BUILD_NUMBER = '2.17.0';
export const BUILD_DATE   = '2026-07-21';
